import React, {useContext, useEffect} from "react";
import {Col, Container, FloatingLabel, Row, Form, Button} from "react-bootstrap";
import {useIntl} from "react-intl";
import messages from "../../i18n/messages";
import {AuthContext} from "../../contexts/auth/AuthContext";
import {LoadingContext} from "../../contexts/loading/LoadingContext";
import {userLogin} from "../../utils/AuthUtil";
import {useNavigate} from "react-router-dom";
import {NavContext} from "../../contexts/navigation/NavContext";


const Login = () => {
    const intl = useIntl()
    const navigate = useNavigate();
    const [authContext, setContext] = useContext(AuthContext);
    const [, setLoadingContext] = useContext(LoadingContext);
    const [navContext,] = useContext(NavContext);
    let username = '';
    let password = '';

    const handleUsernameChange = (event) => {
        username = event.target.value.toString();
    }
     const handlePasswordChange = (event) => {
        password = event.target.value.toString();
     }

    const onClick = (setContext, setLoadingContext) => {
        setLoadingContext({
            isLoading: true,
            loadingText: intl.formatMessage(messages.loginLoadingText),
        });
        userLogin(username, password)
            .then(response => response.json())
            .then(response => {
                setContext({
                    isAuthenticated: true,
                    user: response.username,
                    email: response.emailAddress,
                    token: response.token,
                    isAdmin: response.admin,
                });
                // go back to navContext
                navigate(navContext);
            })
            .catch(error => {
                console.log(error);
            })
            .finally(() => {
                setTimeout(() => {
                    setLoadingContext({
                        isLoading: false,
                        loadingText: '',
                    });
                }, 100);
            });
    }


    return (
        <Container>
            <br/>
            <Row>
                <Col>
                    {intl.formatMessage(messages.privateContentText)}
                </Col>
            </Row>
            <br/>
            <hr/>
            <Row>
                <Col xs={12} sm={12} md={{span: 4, offset: 4}}>
                    <FloatingLabel label={intl.formatMessage(messages.usernameOrEmailInputLabel)}>
                        <Form.Control
                            type="text"
                            placeholder={intl.formatMessage(messages.usernameOrEmailInputLabel)}
                            onChange={handleUsernameChange}
                        />
                    </FloatingLabel>
                </Col>
            </Row>
            <br/>
            <Row>
                <Col xs={12} sm={12} md={{span: 4, offset: 4}}>
                    <FloatingLabel label={intl.formatMessage(messages.passwordInputLabel)}>
                        <Form.Control
                            type="password"
                            placeholder={""}
                            onChange={handlePasswordChange}
                        />
                    </FloatingLabel>
                </Col>
            </Row>
            <br/>
            <Row>
                <Col xs={12} sm={12} md={{span: 4, offset: 4}}>
                    <Button onClick={() => onClick(setContext, setLoadingContext)}>
                        {intl.formatMessage(messages.loginButtonLabel)}
                    </Button>
                </Col>
            </Row>
        </Container>
    );
}

export default Login;